import DropdownForm from '@App/kit/fields/DropdownForm'
import InputTextForm from '@App/kit/fields/InputTextForm'
import React from 'react'
import CheckboxForm from '@App/kit/fields/CheckboxForm'
import { DiscriminatedFormFields } from '@App/forms/common/discriminated-form-fields'
import { FormFieldTypes } from '@App/enum/form-field-types'
import MultiDropdownForm from '@Fields/MultiDropdownForm'
import RadioButtonForm from '@Fields/RadioButtonForm'
import CheckboxGroupForm from '@Fields/CheckboxGroupForm'

const FormFieldFromProps = (props: DiscriminatedFormFields) => {
    const getFormFieldComponent = () => {
        switch (props.type) {
            case FormFieldTypes.DROPDOWN:
                return <DropdownForm {...props} />
            case FormFieldTypes.CHECKBOX:
                return <CheckboxForm {...props}>{props.children && props.children} </CheckboxForm>
            case FormFieldTypes.CHECKBOX_GROUP:
                return <CheckboxGroupForm {...props} />
            case FormFieldTypes.TEXT:
                return <InputTextForm {...props} />
            case FormFieldTypes.RADIO:
                return <RadioButtonForm {...props} />
            case FormFieldTypes.MULTI_DROPDOWN:
                return <MultiDropdownForm {...props} />
        }
    }

    const { inputHeader } = props

    if (inputHeader) {
        return (
            <>
                {inputHeader}
                {getFormFieldComponent()}
            </>
        )
    } else {
        return getFormFieldComponent()
    }
}

export default FormFieldFromProps
